import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';
import { LoaderDebugSnapshot } from '../../models/loading-debug.models';
import { LoaderScope } from '../../models/loading.models';
import { LoaderDebugService } from '../../services/loader-debug.service';

@Component({
  selector: 'myt-app-loading-debug-panel',
  templateUrl: './app-loading-debug-panel.component.html',
  styleUrls: ['./app-loading-debug-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppLoadingDebugPanelComponent {
  readonly collapsed$ = new BehaviorSubject<boolean>(true);
  readonly activeLoaderCount$ = this.loaderDebugService.activeLoaderCount$;
  readonly expandedSnapshot$: Observable<LoaderDebugSnapshot | null> =
    this.collapsed$.pipe(
      switchMap((collapsed) =>
        collapsed ? of(null) : this.loaderDebugService.snapshot$
      )
    );

  constructor(private readonly loaderDebugService: LoaderDebugService) {}

  toggleCollapsed(): void {
    this.collapsed$.next(!this.collapsed$.value);
  }

  clearAll(): void {
    this.loaderDebugService.clearAll();
  }

  clearScope(scopeType: LoaderScope['type'], scopeKey: string): void {
    this.loaderDebugService.clearScope({ type: scopeType, key: scopeKey });
  }

  trackByTokenId(_: number, loaderDebugEntry: LoaderDebugSnapshot['entries'][number]): string {
    return loaderDebugEntry.tokenId;
  }
}
